import React from 'react';
import picture from '../assets/hero-able.svg'; // original illustration, scripts/hero-illustration.py
import ModernHero from './modern/ModernHero';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
// Words are in sites/able/site.json "home".
export default function Hero() {
  return <ModernHero image={picture} />;
}
